<template>
  <div ref="demo" class="demo" @scroll="onTimelineScroll" style="display:none;">
    <div class="line">
      <div ref="intro" class="intro">
        <div ref="mp" class="mixpoint"></div>
      </div>
      <div ref="outro" class="outro"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.intro {
  position: absolute;
  height: 30px;
  // height:100%;
  left: -1000px;
  width: 0;
  overflow: hidden;
  // z-index: 1000;
  bottom: 0;
  .mixpoint {
    position: absolute;
    width: 1px;
    height: 100%;
    background: #18b9e7;
  }
}
.outro {
  position: absolute;
  width: 0;
  height: 30px;
  left: -1000px;
  overflow: hidden;
}
.demo {
  position: relative;
  height: 30px;
  width: 100%;
  margin-top: 0px;
  background-color: #fafafa;
  overflow-y: visible;
  overflow-x: hidden;

  .line {
    min-height: 30px;
    position: relative;
    overflow: visible;
  }
}
</style>

<script>
import moment, { duration } from "moment";
import WaveSurfer from 'wavesurfer.js/dist/wavesurfer.min';

export default {
  name: "DemoTracks",
  props: {
    introBlob: Blob,
    outroBlob: Blob,
    intro: Object,
    outro: Object,
    fadeInStart: { type: Number, default: 5000 },
    fadeInStop: { type: Number, default: 10000 },
    fadeOutStart: { type: Number, default: 300000 },
    fadeOutStop: { type: Number, default: 312000 },
    mixPoint: { type: Number, default: 308000 }
  },
  data() {
    return {
      duration: 0,
      width: 0,
      blocks: [],
      pxPerSecond: 1,
      introIsPlaying: false,
      outroIsPlaying: false
    };
  },
  watch: {
    intro: "setIntro",
    fadeInStart: "setIntro",
    extro: "setOutro",
    mixPoint: "setOutro",
    introBlob: "setIntroWave",
    outroBlob: "setOutroWave"
  },
  methods: {
    reset() {
      if (this.introWave) {
        this.introWave.stop();
        this.introWave.destroy();
        delete this.introWave;
      }
      if (this.outroWave) {
        this.outroWave.stop();
        this.outroWave.destroy();
        delete this.outroWave;
      }
    },
    updateVolume(pos) {
      this.updateIntroPos(pos);
      this.updateOutroPos(pos);
    },
    updateOutroPos(pos) {
      // console.clear()
      // console.log("updateOutro", {
      //     mixPoint:this.mixPoint
      // });

      const outroStartPos = this.mixPoint;
      if (this.outroWave) {
        const outroEndPos = outroStartPos + this.outroWave.getDuration() * 1000;
        if (pos > outroStartPos && pos < outroEndPos) {
          // cursor is in outro track
          if (!this.outroIsPlaying) {
            // console.log("Outro not playing");
            this.outroIsPlaying = true;
            const playpos = pos - outroStartPos;
            this.outroWave.play(playpos / 1000);
          } else {
          }
        } else {
          if (this.outroIsPlaying) {
            this.outroWave.stop();
            this.outroIsPlaying = false;
          }
        }
      }
    },
    updateIntroPos(pos) {
      return;
      const introStartPos = this.fadeInStart - this.intro.mixPoint;
      if (this.introWave) {
        const introEndPos = introStartPos + this.introWave.getDuration() * 1000;
        const fadeStart = this.fadeInStart;

        if (pos > introStartPos && pos < introEndPos) {
          // cursor is in intro track
          if (!this.introIsPlaying) {
            this.introIsPlaying = true;
          }

          const playpos = pos - introStartPos;

          this.introWave.play(playpos / 1000);
          if (pos < fadeStart) {
            this.introWave.setVolume(1);
          } else {
            const fadeOffset = introEndPos - pos;
            const volume = fadeOffset / (introEndPos - introStartPos);
            this.introWave.setVolume(volume);
          }
        } else {
          if (this.introIsPlaying) {
            this.introWave.stop();
            this.introIsPlaying = false;
          }
        }
      }
    },
    pause() {
      this.introWave.pause();
      this.outroWave.pause();
    },
    setIntro() {
      //console.log("Set Intro :",this.pxPerSecond);
      const fadeInStart =
        ((this.fadeInStart - this.intro.mixPoint) / 1000) * this.pxPerSecond;
      this.$refs.intro.style.left = fadeInStart + "px";
    },

    setOutro() {
      const mixpos = (this.mixPoint / 1000) * this.pxPerSecond;
      this.$refs.outro.style.left = mixpos + "px";
    },
    resize(width, pxPerSecond) {
      const line = this.$refs.demo.querySelector(".line");
      if (!line) return;
      this.width = width;
      this.pxPerSecond = pxPerSecond;
      line.style.width = width + "px";
      // this.setBlocks()
      this.introWave && this.introWave.zoom(this.pxPerSecond);
      this.outroWave && this.outroWave.zoom(this.pxPerSecond);
      this.setIntro();
      this.setOutro();
      // const fadeInStart = ((this.fadeInStart - this.intro.mixPoint) / 1000) * this.pxPerSecond
      // this.$refs.intro.style.left = fadeInStart + 'px'
    },
    setIntroWave() {
      if (this.introWave) {
        this.introWave.stop();
        this.introWave.destroy();
        delete this.introWave;
      }
      if (this.introBlob) {
        this.introWave = WaveSurfer.create({
          container: this.$refs.intro,
          waveColor: "#999",
          progressColor: "#666",
          barWidth: 2,
          barGap: 1,
          height: 20,
          barHeight: 1,
          // autoCenter: true,
          forceDecode: true,
          interact: false,
          cursorWidth: 0,
          responsive: true
          // minPxPerSec: 1
        });
        this.introWave.on("ready", () => {
          //console.log("intro ready --> here", this.pxPerSecond);
          // this.introWave.zoom(this.pxPerSecond)
          const ratio = this.introWave.getDuration() / this.duration;
          // console.log(
          //   "ratio,",
          //   ratio,
          //   this.duration,
          //   this.introWave.getDuration(),
          //   this.width * ratio
          // );
          const mixPosition =
            (this.intro.mixPoint / 1000 / this.introWave.getDuration()) * 100;
          //console.log("mixpost", mixPosition);
          this.$refs.mp.style.left = mixPosition + "%";
          this.$refs.intro.style.width = ratio * 100 + "%";
          const fadeInStart =
            ((this.fadeInStart - this.intro.mixPoint) / 1000) *
            this.pxPerSecond;
          this.$refs.intro.style.left = fadeInStart + "px";
          this.introWave.zoom(this.pxPerSecond);
          this.$emit("intro-ready");
        });
        this.introWave.loadBlob(this.introBlob);
      }
    },
    setOutroWave() {
		// console.clear();
      //console.log("Set outro wave");
      if (this.outroWave) {
        //console.log("Clearing Extro");
        this.outroWave.stop();
        this.outroWave.destroy();
        delete this.outroWave;
	  }

      if (this.outroBlob) {
        //console.log("Creating", this.outroBlob);
        try {
          this.outroWave = WaveSurfer.create({
            container: this.$refs.outro,
            waveColor: "#999",
            progressColor: "#666",
            barWidth: 2,
            barGap: 1,
            height: 20,
            barHeight: 1,
            // autoCenter: true,
            forceDecode: true,
            interact: false,
            cursorWidth: 0,
            responsive: true,
            // minPxPerSec: 1
          });
          this.outroWave.on("ready", () => {
            //console.log("outro ready", this.pxPerSecond);
            // this.introWave.zoom(this.pxPerSecond)
            const ratio = this.outroWave.getDuration() / this.duration;
            // console.log(
            //   {
            //   ratio,
            //   duration : this.duration,
            //   waveDuration : this.outroWave.getDuration(),
            //   width : this.width * ratio
            //   }
            // );
            // const mixPosition = ((this.intro.mixPoint / 1000) / this.outroWave.getDuration()) * 100
            // console.log('mixpost', mixPosition)
            // this.$refs.mp.style.left = mixPosition + '%'
            this.$refs.outro.style.width = ratio * 100 + "%";
            const mixpos = (this.mixPoint / 1000) * this.pxPerSecond;
            this.$refs.outro.style.left = mixpos + "px";
            this.outroWave.zoom(this.pxPerSecond);
            this.$emit("outro-ready");
          });
          this.outroWave.loadBlob(this.outroBlob);
        } catch (error) {
          console.log("Error");
        }
        //console.log("Created");
      }
    },

    setDuration(duration) {
      //console.log("set duration", duration);
      this.duration = duration;
      //this.setIntroWave()
      this.setOutroWave() 
    },
    scrollTo(scrollLeft) {
      this.$refs.demo.scrollLeft = scrollLeft;
    },
    setBlocks() {
      const numBlocks = Math.floor(this.duration / 30);
      const blockWidth = this.pxPerSecond * 30;
      const blocks = [];
      for (let i = 0; i < numBlocks; i++) {
        const label = moment((i + 1) * 30000).format("mm:ss");
        blocks.push({
          label,
          width: blockWidth
        });
      }
      this.blocks = blocks;
    },
    onTimelineScroll(e) {
      const scrollLeftRatio = e.target.scrollLeft / e.target.scrollWidth;
      this.$emit("scroll", scrollLeftRatio, e.target.scrollLeft);
    }
  }
};
</script>
